/**
 * Sidebar menu items.
 *
 * Access gating fields (read by Layout.jsx filter):
 *   - permissions: string[]  — show if user has ANY of these permission codes
 *   - roles:       string[]  — legacy gate, still used for "store" role users
 *
 * Super admin sees everything (short-circuit in Layout.jsx).
 * A `type: "sub"` parent is auto-hidden if all its children get filtered out.
 */
export const MENUITEMS = [
  {
    menutitle: "Main Menus",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "Dashboard",
        icon: "dashboard",
        type: "link",
        active: true,
        path: `/dashboard`,
        permissions: ["dashboard.view"],
      },
      {
        title: "Orders",
        icon: "order",
        type: "link",
        active: false,
        path: `/orders`,
        permissions: ["orders.list"],
      },
      {
        title: "Products",
        icon: "product",
        active: false,
        type: "sub",
        path: ``,
        badge: "badge badge-light-danger",
        children: [
          { path: `/products`, title: "Products", type: "link", permissions: ["items.list"] },
          { path: `/brands`, title: "Brands", type: "link", permissions: ["brands.list"] },
          { path: `/collections`, title: "Category", type: "link", permissions: ["collections.list"] },
          { path: `/sub-collections`, title: "Sub-Category", type: "link", permissions: ["sub_collections.list"] },
          { path: `/group-tags`, title: "Group Tags", type: "link", permissions: ["group_tags.list"] },
          { path: `/variants`, title: "Variants", type: "link", permissions: ["items.list"] },
        ],
        permissions: ["items.list", "brands.list", "collections.list", "sub_collections.list","group_tags.list"],
        // roles: ["store"],
      },
      {
        title: "Stores",
        icon: "store",
        type: "link",
        path: `/stores`,
        badge: "badge badge-light-danger",
        active: false,
        permissions: ["stores.list"],
      },
      {
        title: "Coupons",
        icon: "store",
        type: "link",
        path: `/coupons`,
        badge: "badge badge-light-danger",
        active: false,
        permissions: ["coupons.list"],
      },
      {
        title: "Stock Management",
        icon: "statistic",
        type: "sub",
        active: false,
        path: ``,
        badge: "badge badge-light-danger",
        children: [
          { path: `/transfer`, title: "Transfer", type: "link", permissions: ["stock.list"] },
          { path: `/inventory/stores`, title: "Store Management", type: "link", permissions: ["stock.list"] },
          { path: `/inventory/suppliers`, title: "Supplier Management", type: "link", permissions: ["stock.list"] },
          { path: `/inventory/purchase-orders`, title: "Purchase Orders", type: "link", permissions: ["stock.list"] },
          { path: `/inventory/returns-to-supplier`, title: "Return to Supplier", type: "link", permissions: ["stock.list"] },
          { path: `/inventory/adjustments`, title: "Stock Adjustments", type: "link", permissions: ["stock.adjust"] },
          { path: `/inventory/stocktakes`, title: "Stocktake", type: "link", permissions: ["stock.list"] },
          { path: `/inventory/bulk-upload`, title: "Bulk Upload", type: "link", permissions: ["stock.create"] },
          { path: `/inventory/movements`, title: "Movement Log", type: "link", permissions: ["stock.view"] },
          { path: `/inventory/reports`, title: "Inventory Reporting", type: "link", permissions: ["reports.list"] },
        ],
        permissions: ["stock.list", "stock.adjust", "stock.create", "stock.view"],
      },
      {
        title: "Customers",
        icon: "customer",
        type: "sub",
        active: false,
        path: ``,
        badge: "badge badge-light-danger",
        children: [
          { path: `/customers`, title: "Customers", type: "link", permissions: ["customers.list"] },
          { path: `/tag`, title: "Tag", type: "link", permissions: ["tags.list"] },
          { path: `/apply-tags`, title: "Apply Tags", type: "link", permissions: ["customers.update"] },
          { path: `/delivery-zone-requests`, title: "Delivery Zone Requests", type: "link", permissions: ["stores.list"] },
        ],
        permissions: ["customers.list", "tags.list", "customers.update", "stores.list"],
      },
      {
        title: "Employees",
        icon: "user",
        type: "link",
        active: false,
        path: `/employees`,
        permissions: ["employees.list"],
      },
      {
        title: "Business",
        icon: "customer",
        type: "sub",
        active: false,
        path: ``,
        badge: "badge badge-light-danger",
        children: [
          { path: `/business`, title: "Business", type: "link", permissions: ["b2b.list"] },
          { path: `/business/landing-content`, title: "Landing Content", type: "link", permissions: ["b2b.list"] },
          { path: `/business/address`, title: "Address Approval", type: "link", permissions: ["b2b.list"] },
        ],
        permissions: ["b2b.list"],
      },
      {
        title: "Role Management",
        icon: "role",
        type: "link",
        active: false,
        path: `/role-management`,
        permissions: ["roles.list"],
      },
      {
        title: "Delivery Partners",
        icon: "user",
        type: "link",
        active: false,
        path: `/delivery-partners`,
        permissions: ["partners.list"],
      },
      {
        title: "Reports",
        icon: "report",
        type: "sub",
        path: ``,
        badge: "badge badge-light-danger",
        active: false,
        children: [
          { path: `/reports`, title: "Reports", type: "link", permissions: ["reports.list"] },
          { path: `/reports/gp`, title: "GP Reports", type: "link", permissions: ["reports.list"] },
        ],
        permissions: ["reports.list"]
      },
      {
        title: "CMS",
        icon: "role",
        active: false,
        type: "sub",
        path: ``,
        badge: "badge badge-light-danger",
        children: [
          { path: `/banner`, title: "Banner", type: "link", permissions: ["content.list"] },
          { path: `/notice`, title: "Notice", type: "link", permissions: ["notices.list"] },
          { path: `/blog`, title: "Blog", type: "link", permissions: ["blogs.list"] },
          { path: `/blog-categories`, title: "Blog Categories", type: "link", permissions: ["blog_categories.list"] },
          { path: `/blog-comments/pending`, title: "Blog Pending Comments", type: "link", permissions: ["blogs.list"] },
          { path: `/app-versions`, title: "App Version", type: "link", permissions: ["content.list"] },
        ],
        permissions: ["content.list", "notices.list", "blogs.list", "blog_categories.list"],
      },
      {
        title: "Offers",
        icon: "product",
        type: "sub",
        active: false,
        path: ``,
        badge: "badge badge-light-danger",
        children: [
          { path: `/loyalty`, title: "Loyalty", type: "link", permissions: ["loyalty.list"] },
          { path: `/product-boost`, title: "Product Boost", type: "link", permissions: ["boost.list"] },
          { path: `/reward`, title: "Bottle Stamps", type: "link", permissions: ["content.list"] },
          { path: `/special`, title: "Special Category", type: "link", permissions: ["items.list"] },
          { path: `/flash-deals`, title: "Flash Deals", type: "link", permissions: ["items.list"] },
        ],
        permissions: ["loyalty.list", "boost.list","items.list"],
      },
      // {
      //   title: "Special Category",
      //   icon: "product",
      //   type: "link",
      //   active: false,
      //   path: `/special`,
      //   permissions: ["items.list"],
      // },
      {
        title: "SEO",
        icon: "setting",
        type: "sub",
        active: false,
        permissions: ["seo_pages.list"],
        children: [
          {
            path: `/settings/seo/static-pages`,
            title: "Static Pages",
            type: "link",
            permissions: ["seo_pages.list"],
          },
        ],
      },
      // {
      //   title: "My Store",
      //   icon: "store",
      //   type: "link",
      //   path: `/store`,
      //   badge: "badge badge-light-danger",
      //   active: false,
      //   roles: ["store"],
      // },
      {
        title: "Email Marketing",
        icon: "email",
        type: "link",
        path: `/email-marketing`,
        active: false,
        permissions: ["mailchimp.list"],
      },
      {
        title: "Transactions",
        icon: "transaction",
        type: "link",
        active: false,
        path: `/transactions`,
        permissions: ["transaction.list"],
      },
      {
        title: "Activity Log",
        icon: "log",
        type: "link",
        active: false,
        path: `/activity-log`,
        permissions: ["activities.view"],
      },
      {
        title: "Policies & content",
        icon: "setting",
        type: "sub",
        active: false,
        path: ``,
        badge: "badge badge-light-danger",
        children: [
          { path: `/policies/faq`, title: "FAQ", type: "link" },
          { path: `/policies/return-policy`, title: "Return Policy", type: "link" },
          { path: `/policies/privacy-policy`, title: "Privacy Policy", type: "link" },
          { path: `/policies/terms-and-conditions`, title: "Terms and Conditions", type: "link" },
          { path: `/policies/about-us`, title: "About Us", type: "link" },
          { path: `/policies/contact-us`, title: "Contact Us", type: "link" },
          { path: `/policies/announcements`, title: "Marquee", type: "link" },
        ],
        roles: ["admin", "Super Admin"],
      },
      // {
      //   title: "CMS",
      //   icon: "role",
      //   type: "sub",
      //   active: false,
      //   path: ``,
      //   badge: "badge badge-light-danger",
      //   children: [
      //     { path: `/cms`, title: "Banner", type: "link" },
      //     { path: `/loyalty`, title: "Loyalty", type: "link" },
      //   ],
      //   roles: ["admin"],
      // },
      // {
      //   title: 'Log Activity',
      //   icon: 'log',
      //   type: 'link',
      //   active: false,
      //   path: `/activity`
      // },
    ],
  },
];
